import { render } from "./MsgGuideTips.vue?vue&type=template&id=650d1d12"
import script from "./MsgGuideTips.vue?vue&type=script&lang=js"
export * from "./MsgGuideTips.vue?vue&type=script&lang=js"

import "./MsgGuideTips.vue?vue&type=style&index=0&id=650d1d12&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__